const TestimonialSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3">
            <div className="mb-6">
              <span className="text-sm font-medium text-dark flex items-center gap-2">
                <span className="w-2 h-2 bg-primary rounded-full"></span>
                CLIENT TESTIMONIAL
              </span>
            </div>
            <div className="mb-8">
              <i className="ri-double-quotes-l text-6xl text-primary mb-4 block"></i>
              <blockquote className="text-4xl lg:text-5xl font-serif font-bold text-dark leading-tight mb-8">
                Security Bay Area transformed our building's security infrastructure with professionalism and expertise
              </blockquote>
              <div className="flex items-center gap-3">
                <strong className="text-lg text-dark">Michael Chen</strong>
                <div className="flex items-center gap-1">
                  <i className="ri-star-fill text-green-500"></i>
                  <i className="ri-star-fill text-green-500"></i>
                  <i className="ri-star-fill text-green-500"></i>
                  <i className="ri-star-fill text-green-500"></i>
                  <i className="ri-star-fill text-green-500"></i>
                </div>
                <i className="ri-verified-badge-fill text-blue-500 text-xl"></i>
              </div>
              <p className="text-gray-600 text-sm mt-2">Property Manager, Downtown San Francisco</p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="rounded-2xl overflow-hidden h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/a7dfeff2c8c6c8833de7cd26e3051672.jpg"
                alt="Michael Chen"
                className="w-full h-full object-cover object-top grayscale"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;